const DEBUG_LOCAL_STORAGE_KEY = "debug";

let cachedDebugEnabled: boolean | null = null;

const readDebugEnabled = (): boolean =>
  typeof localStorage !== "undefined" &&
  localStorage.getItem(DEBUG_LOCAL_STORAGE_KEY) === "true";

if (typeof window !== "undefined") {
  window.addEventListener("storage", (event) => {
    if (event.key === DEBUG_LOCAL_STORAGE_KEY) {
      cachedDebugEnabled = null;
    }
  });
}

export const isDebugEnabled = (): boolean => {
  if (cachedDebugEnabled === null) {
    cachedDebugEnabled = readDebugEnabled();
  }
  return cachedDebugEnabled;
};

export const setDebugEnabled = (enabled: boolean): void => {
  if (typeof localStorage === "undefined") return;
  localStorage.setItem(DEBUG_LOCAL_STORAGE_KEY, String(enabled));
  cachedDebugEnabled = enabled;
};
